import LocalRepository from "../repository/local-repository";
import * as types from "../mutation-types";

const themeKey = "appTheme";
const THEME_LIGHT = "light";
const THEME_DARK = "dark";

function resolveInitialTheme() {
  const saved = LocalRepository.getData(themeKey);
  if (saved === THEME_LIGHT || saved === THEME_DARK) {
    return saved;
  }
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? THEME_DARK : THEME_LIGHT;
  }
  return THEME_LIGHT;
}

function applyThemeToDocument(theme) {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", theme);
  document.body && document.body.setAttribute("data-theme", theme);
}

const initialTheme = resolveInitialTheme();
applyThemeToDocument(initialTheme);

export const state = {
  theme: initialTheme,
};

export const getters = {
  theme: (state) => state.theme,
  isDarkTheme: (state) => state.theme === THEME_DARK,
  isLightTheme: (state) => state.theme === THEME_LIGHT,
};

export const mutations = {
  [types.SET_THEME](state, theme) {
    state.theme = theme;
    LocalRepository.setData(themeKey, theme);
    applyThemeToDocument(theme);
  },
};

export const actions = {
  setTheme({ commit }, theme) {
    const next = theme === THEME_DARK ? THEME_DARK : THEME_LIGHT;
    commit(types.SET_THEME, next);
  },
  toggleTheme({ state, dispatch }) {
    dispatch("setTheme", state.theme === THEME_DARK ? THEME_LIGHT : THEME_DARK);
  },
};
